import { A11yModule } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { RouterLink } from '@angular/router';
import { Stammdaten } from '@ebeihilfe/core';
import { KurzantragBase } from '@ebeihilfe/einreichung-old';
import { LegacyAntragsMetadata } from '@ebeihilfe/einreichung-shared/model';
import { DynamicFormComponent } from '@ebeihilfe/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'portal-antrag-modal',
  templateUrl: './antrag-modal.component.html',
  styleUrls: ['./antrag-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatDialogModule,
    TranslateModule,
    A11yModule,
    MatDividerModule,
    ReactiveFormsModule,
    RouterLink,
    MatButtonModule,
    DynamicFormComponent,
  ],
})
export class AntragModalComponent extends KurzantragBase implements OnInit {
  private readonly stammdaten: Stammdaten = inject(MAT_DIALOG_DATA);
  private readonly dialogRef: MatDialogRef<AntragModalComponent> = inject(MatDialogRef<AntragModalComponent>);

  public ngOnInit(): void {
    this.userData = this.stammdaten;
    super.ngOnInit();
  }

  public updateModel(model: Record<string, unknown>): void {
    this.model = model;
  }

  protected closeUp(antragsMetadata: LegacyAntragsMetadata[]): void {
    this.dialogRef.close({
      type: this.form.value['antragsArt'], // 💩 we shouldn't need hard coded stuff
      data: antragsMetadata,
    });
  }
}
